import React, { Component } from "react";
import CensoComponent from '../components/CensoComponent';
import Landing from '../../landing/containers/LandingContainer';
import { api_base } from '../../constants/services/api'
import { sendService } from "../../Services/service";
import ViewCenso from "../components/ViewCesno";


import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import * as actions from '../../Actions/Dashboard';
import * as ModalActs from '../../Actions/Modal';

import "../style.css";


class CensoContainer extends Component {
  state = {
    cant: '',
    getqrs: false,
    censoList: [],
    control: { count: 0, page: '0', pages: 0, pageSize: 20 },
    searchError: false,
    search: '',
    loading: false,
    filterIep: '0',
    startDate: '',
    endDate: '',
    ieps: [],
    barrioFilter: [],
    barrio: '0',
  }

  onChangeRoute = (route) => {
    this.props.actions.activePage(route);
    this.props.history.push(route);
  }

  handlerTextPunto = e => {
    if (e.target.value === '') this.setState({ getqrs: false })
    else this.setState({ cant: parseInt(e.target.value), getqrs: true })
  }

  handlerSearch = e => {
    this.setState({
      search: e.target.value,
      searchError: false
    })
  }

  handlerKeyUp = e => {
    if (e.keyCode === 13)
      this.getSearch()
  }

  getSearch = () => {
    this.getPageData()
  }

  getQrs = () => {
    if (this.state.getqrs)
      window.open(`${api_base}/api/v1/ep/getqr?cant=${this.state.cant}`, '_blank')
  }

  getQr = (qr) => {
    window.open(`${api_base}/api/v1/ep/getqr?qr=${qr}`, '_blank')
  }

  componentDidMount() {
    this.getPageData()
  }

  getPageData = (page = 0) => {
    this.setState({ loading: true })
    sendService(`/api/v1/censo/getpageable?page=${page}&search=${this.state.search}`, "GET").then(value => {
      this.setState({ censoList: value.response.rows, control: value.response.control, loading: false })
    })
  };

  openCenso = (id) => {
    sendService(`/api/v1/censo/get/${id}`, "GET").then(value => {
      this.props.modalActions.openModal(
        <ViewCenso close={this.props.modalActions.closeModal} censoData={value.response} onSave={(s) => this.editCenso(s)} />
      )
    })

    this.props.modalActions.openModal(
      <div>cargando...</div>
    )
  }

  getPdf = (id) => {
    window.open(`${api_base}/api/v1/censo/getPdfDocument/${id}`, '_blank')
  }

  editCenso = (data) => {
    this.props.modalActions.closeModal()
    this.props.modalActions.openLoader()
    sendService(`/api/v1/censo/edit`, "POST", data).then(value => {
      this.props.modalActions.closeLoader()
      if (value.status !== 200) {
        alert('Problemas con la carga de los datos')
      }
    })
  }

  render() {
    return (
      <Landing history={this.props.history} hasFooter={false}>
        <CensoComponent
          state={this.state}
          session={this.props.session}
          onChangeRoute={this.onChangeRoute}
          handlerTextPunto={this.handlerTextPunto}
          handlerSearch={this.handlerSearch}
          searchKeyUp={this.handlerKeyUp}
          onGetSearch={this.getSearch}
          onGetPdf={this.getPdf}
          onOpenCenso={this.openCenso}
          onChangePage={this.getPageData}
        />
      </Landing>
    );
  }
}

function mapStateToProps(state) {
  return {
    session: state.session
  }
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators(actions, dispatch),
    modalActions: bindActionCreators(ModalActs, dispatch),
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(CensoContainer);